import type { IntegrationHostName } from '../../contexts/ClientNameContext';
import { getPageType } from '../../routing';

enum IntegrationSource {
  PrSequences = 'PrSequences',
  PrBrowse = 'PrBrowse',
  PrViewer = 'PrViewer',
  AeCompositions = 'AeCompositions',
  AeBrowse = 'AeBrowse',
  AeViewer = 'AeViewer',
}
const SOURCE_MAPS: Record<
  IntegrationHostName,
  Record<string, IntegrationSource>
> = {
  premiere: {
    sequences: IntegrationSource.PrSequences,
    folder: IntegrationSource.PrBrowse,
    folderViewer: IntegrationSource.PrViewer,
  },
  aftereffects: {
    sequences: IntegrationSource.AeCompositions,
    folder: IntegrationSource.AeBrowse,
    folderViewer: IntegrationSource.AeViewer,
  },
};

/**
 * Determines the host-specific source enum from which the tracking event was initiated.
 */
export function getSourceFromPath(
  pathname: string,
  host: IntegrationHostName
): IntegrationSource | string {
  const pageType = getPageType(pathname) || 'not defined';
  return SOURCE_MAPS[host][pageType] ?? pageType;
}
